import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getPoHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
   const url = endPoint.dynamicList({ path: "purchase_order",...action.payload });

const { data } = yield call(apiClient.get, `${url}`);
    yield put({
      type: types.GET_PO_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_PO_ERROR,
      payload,
    });
  }
}

export function* getPoWatcherSaga() {
  yield takeLatest(types.GET_PO_START, getPoHandlerSaga);
}

//delete

function* deletePoHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("purchase_order", action.payload),
    );
    yield put({
      type: types.DELETE_PO_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_PO_ERROR,
      payload,
    });
  }
}

export function* deletePoWatcherSaga() {
  yield takeLatest(types.DELETE_PO_START, deletePoHandlerSaga);
}

//single item

function* getSinglePoHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `purchase_order/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_PO_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_PO_ERROR,
      payload,
    });
  }
}

export function* getSinglePoWatcherSaga() {
  yield takeLatest(types.SINGLE_PO_START, getSinglePoHandlerSaga);
}

//update
function* updatePoHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { path, dataId, body } = action.payload;
    const { data } = yield call(
      apiClient.put,
      endPoint.dynamicUpdateItem({ path }),
      { _id: dataId, ...body }
    );
    yield put({
      type: types.UPDATE_PO_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.UPDATE_PO_ERROR,
      payload,
    });
  }
}

export function* updatePoWatcherSaga() {
  yield takeLatest(types.UPDATE_PO_START, updatePoHandlerSaga);
}

